import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NavbarLanding = ({ menuItems }) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentMenu, setCurrentMenu] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
    });
    const [loading, setLoading] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isSmallLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));

    const handleMenuOpen = (event, menuName) => {
        setAnchorEl(event.currentTarget);
        setCurrentMenu(menuName);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setCurrentMenu(null);
    };

    const handleScrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
            handleMenuClose();
            setDrawerOpen(false);
        }
    };

    const handleDialogOpen = () => {
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
        setFormData({ name: "", email: "", phone: "" });
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        const scriptURL =
            "https://script.google.com/macros/s/AKfycbzJE9ydPWcUU04hJca0Td7O08iOUV9xAUaX9U-IcpFx0Bq6dMe2NcH63cS82dHPP8pX/exec";

        try {
            await fetch(scriptURL, {
                method: "POST",
                mode: "no-cors",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            alert("Your details have been submitted successfully!");
            handleDialogClose();
        } catch (error) {
            console.error("Error:", error);
            alert("Failed to submit. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <AppBar position="static" color="transparent" elevation={0}>
                <Toolbar
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: isMobile || isTablet ? "0 10px" : "0 20px",
                    }}
                >
                    <Typography
                        style={{
                            fontWeight: "bold",
                            fontSize: isMobile
                                ? "20px"
                                : isSmallLaptop
                                    ? "28px"
                                    : "32px",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Vocation<span style={{ color: "red" }}>IQ</span>
                    </Typography>

                    {(isMobile || isTablet) ? (
                        <>
                            <IconButton
                                onClick={() => setDrawerOpen(true)}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Drawer
                                anchor="right"
                                open={drawerOpen}
                                onClose={() => setDrawerOpen(false)}
                            >
                                <Box
                                    style={{
                                        width: 250,
                                        padding: "10px",
                                    }}
                                >
                                    <List>
                                        {Object.keys(menuItems).map((menu) => (
                                            <React.Fragment key={menu}>
                                                {menuItems[menu] ? (
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls={`${menu}-content`}
                                                            id={`${menu}-header`}
                                                        >
                                                            <Typography>{menu}</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            {menuItems[menu].map((item, index) => (
                                                                <ListItem
                                                                    button
                                                                    key={index}
                                                                    onClick={() =>
                                                                        handleScrollToSection(
                                                                            item.replace(/\s+/g, "-").toLowerCase()
                                                                        )
                                                                    }
                                                                >
                                                                    <ListItemText primary={item} />
                                                                </ListItem>
                                                            ))}
                                                        </AccordionDetails>
                                                    </Accordion>
                                                ) : (
                                                    < ListItem
                                                        button
                                                        onClick={() =>
                                                            handleScrollToSection(menu.replace(/\s+/g, "-").toLowerCase())
                                                        }
                                                    >
                                                        <ListItemText primary={menu} />
                                                    </ListItem>
                                                )}
                                            </React.Fragment>
                                        ))}
                                        <ListItem button onClick={handleDialogOpen}>
                                            <ListItemText primary="Register" />
                                        </ListItem>
                                        <ListItem
                                            button
                                            component="a"
                                            onClick={() => navigate("/login")}
                                        >
                                            <ListItemText primary="Login" />
                                        </ListItem>
                                    </List>
                                </Box>
                            </Drawer>
                        </>
                    ) : (
                        <Box
                            style={{
                                display: "flex",
                                gap: isSmallLaptop ? "20px" : "30px",
                            }}
                        >
                            {Object.keys(menuItems).map((menu) => (
                                <React.Fragment key={menu}>
                                    {menuItems[menu] ? (
                                        <>
                                            <Button
                                                onClick={(event) => handleMenuOpen(event, menu)}
                                                style={{
                                                    fontWeight: "bold",
                                                    color: "black",
                                                    textTransform: "none",
                                                    fontSize: isSmallLaptop ? "14px" : "16px",
                                                    fontFamily: "Poppins, sans-serif",
                                                }}
                                            >
                                                {menu}
                                            </Button>
                                            <Menu
                                                anchorEl={anchorEl}
                                                open={currentMenu === menu}
                                                onClose={handleMenuClose}
                                            >
                                                {menuItems[menu].map((item, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        style={{ fontSize: 14 }}
                                                        onClick={() =>
                                                            handleScrollToSection(
                                                                item.replace(/\s+/g, "-").toLowerCase()
                                                            )
                                                        }
                                                    >
                                                        {item}
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </>
                                    ) : (
                                        <Button
                                            onClick={() =>
                                                handleScrollToSection(menu.replace(/\s+/g, "-").toLowerCase())
                                            }
                                            style={{
                                                textTransform: "none",
                                                fontWeight: "bold",
                                                color: "black",
                                                fontSize: isSmallLaptop ? "14px" : "16px",
                                                fontFamily: "Poppins, sans-serif",
                                            }}
                                        >
                                            {menu}
                                        </Button>
                                    )}
                                </React.Fragment>
                            ))}
                            <Button
                                variant="contained"
                                style={{
                                    textTransform: "none",
                                    backgroundColor: "#f7ca17",
                                    color: "white",
                                    fontWeight: "bold",
                                    fontSize: isSmallLaptop ? 20 : 24,
                                    borderRadius: 16,
                                    fontFamily: "Poppins, sans-serif",
                                }}
                                onClick={handleDialogOpen}
                            >
                                Register
                            </Button>
                            <Button
                                variant="contained"
                                style={{
                                    textTransform: "none",
                                    backgroundColor: "#f7ca17",
                                    color: "white",
                                    fontWeight: "bold",
                                    fontSize: isSmallLaptop ? 20 : 24,
                                    borderRadius: 16,
                                    fontFamily: "Poppins, sans-serif",
                                }}
                                onClick={() => navigate("/login")}
                            >
                                Login
                            </Button>
                        </Box>
                    )}
                </Toolbar>
            </AppBar >

            {/* Registration Dialog */}
            < Dialog open={openDialog} onClose={handleDialogClose} >
                <DialogTitle>Register</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            margin="normal"
                        />
                        <TextField
                            fullWidth
                            label="Email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            margin="normal"
                        />
                        <TextField
                            fullWidth
                            label="Phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            margin="normal"
                        />
                        <DialogActions>
                            <Button onClick={handleDialogClose} color="secondary">
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={24} /> : "Submit"}
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog >
        </>
    );
};

export default NavbarLanding;
